
import React from "react";
import { Navigate } from "react-router-dom";
import Quotations from "layouts/quotations";
import Orders from "layouts/orders";
import Users from "layouts/users";
import Notifications from "layouts/notifications";
import Profile from "layouts/profile";
import Export from "layouts/export";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import QuotationsDetails from "layouts/quotationsDetails";
import OrdersDetails from "layouts/ordersDetails";
import ResetPassword from "layouts/authentication/reset-password/cover";
import DefinePassword from "layouts/authentication/reset-password/definePassword.js";
import AccessQuotation from "layouts/quotationsDetails/access-quotations";
import AccessOrder from "layouts/ordersDetails/access-orders";
import Icon from "@mui/material/Icon";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";

import ProtectedRoute from "./ProtectedRoute";


const routes = [
  {
    type: "route",
    name: "Login",
    key: "login",
    route: "/login",
    component: <SignIn />,
  },
  {
    type: "route",
    name: "Sign Up",
    key: "sign-up",
    route: "/sign-up",
    component: <SignUp />,
  },
  {
    type: "collapse",
    name: "Ofertas",
    key: "ofertas",
    icon: <Icon fontSize="small">receipt</Icon>,
    route: "/ofertas",
    component: (
      <ProtectedRoute>
        <Quotations />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Pedidos",
    key: "Pedidos",
    icon: <Icon fontSize="small">shopping_cart_checkout</Icon>,
    route: "/pedidos",
    component: (
      <ProtectedRoute>
        <Orders />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Usuários",
    key: "Usuários",
    icon: <Icon fontSize="small">people</Icon>,
    route: "/usuarios",
    component: <Users />,
  },
  // {
  //   type: "collapse",
  //   name: "Notificações",
  //   key: "notifys",
  //   icon: <Icon fontSize="small">notifications</Icon>,
  //   route: "/notifications",
  //   component: <ProtectedRoute><Notifications /></ProtectedRoute>,
  // },
  {
    type: "collapse",
    name: "Exportar",
    key: "Exportar",
    icon: <FileDownloadOutlinedIcon fontSize="small" />,
    route: "/exportar",
    component: <Export />,
  },
  {
    type: "collapse",
    name: "Perfil",
    key: "profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/perfil",
    component: <Profile />,
  },
  {
    type: "route",
    name: "Detalhes Ofertas",
    key: "oferta-detalhes",
    route: "/ofertas/:id",
    component: <QuotationsDetails />,
  },
  {
    type: "route",
    name: "Detalhes Pedidos",
    key: "pedido-detalhes",
    route: "/pedidos/:id",
    component: <OrdersDetails />,
  },
  {
    type: "route",
    name: "Redefinir Senha",
    key: "reset-password",
    route: "/reset-password",
    component: <ResetPassword />,
  },
  {
    type: "route",
    name: "Definir Senha",
    key: "define-password",
    route: "/define-password/:id",
    component: <DefinePassword />,
  },
  {
    type: "route",
    name: "Acessar Oferta",
    key: "access-quotation",
    route: "/access-quotation/:guid",
    component: <AccessQuotation />,
  },
  {
    type: "route",
    name: "Acessar Pedido",
    key: "access-order",
    route: "/access-order/:guid",
    component: <AccessOrder />,
  }
];

export default routes;